<template>
  <layout-component>
    <div class="banner banner-dashboard">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2 col-lg-7 offset-lg-2">
            <h1 class="left-bullet" v-html="$t('title-banner')"></h1>
            <ul>
              <li><button :class="{'active': type == 'rooms'}" @click="changeType('rooms')">{{'title-rooms'|t}}</button></li>
              <li><button :class="{'active': type == 'events'}" @click="changeType('events')">{{'title-events'|t}}</button></li>
            </ul>

            <b-alert :show="hasError" fade variant="danger">
              <h4><i class="fal fa-times"></i> {{'error-title'|t}}.</h4>
              <p v-html="$t('error-text')"></p>
            </b-alert>

            <b-alert :show="hasRefund" fade variant="success">
              <h4><i class="fal fa-check"></i> {{'refund-title'|t}}.</h4>
              <p v-html="$t('refund-text')"></p>
            </b-alert>

            <template v-if="bookings && $store.rooms.content">
              <div class="select-wrapper mt-3 mt-md-4">
                <b-form-select v-model="mode" @input="changeMode()">
                  <option value="upcoming">{{'upcoming-booking'|t}}</option>
                  <option value="past">{{'past-booking'|t}}</option>
                </b-form-select>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!--
        Events
    -->
    <div class="container cart booking" v-if="type == 'events'">
      <template v-if="events && events.length">
        <div class="row">
          <div class="col-md-12 col-lg-10">
            <b-list-group class="cart-list booking-list">
              <template v-for="(booking,index) in events">
                <b-list-group-item class="cart-item booking-item d-md-flex align-items-md-center justify-content-md-between">
                  <div class="img-wrapper">
                    <div class="room-image" :style="`background-image:url('storage/${booking.eventCover}')`"></div>
                  </div>
                  <div class="text-wrapper d-md-flex align-items-md-start">
                    <div class="left-infos">
                      <h5>{{$i18n.locale == 'fr' ? booking.event.name : booking.event.name_en }} {{ booking.tickets > 1 ? `(x${booking.tickets})` : '' }}</h5>
                      <div class="booking-date">{{booking.date|formatDate}}</div>
                      <div class="booking-hours">{{'from'|t}} {{booking.event.from | formatTimeEvent}} {{'to'|t}} {{booking.event.to | formatTimeEvent}}</div>
                      <div class="booking-price" v-if="booking.price">
                        {{ booking.tickets }} x {{ booking.event.price }}€ = {{ booking.tickets * booking.event.price }} €
                      </div>
                      <div class="booking-price" v-else>{{ booking.tickets }} x {{'event-free'|t}}</div>
                    </div>
                    <div class="right-infos align-self-end">
                      <ul class="links">
                        <li class="details">
                          <router-link :to="/events/+booking.event.slug" active-class="active" class="btn-link btn-link-small">
                            <span>{{'event-details'|t}}</span>
                          </router-link></li>
                      </ul>
                      <ul class="links"  v-if="booking.isCancellable">
                        <li class="cancel" v-if="booking.isValidated">
                          <a href="#" class="btn-link btn-link-small" @click.prevent="openEditModal('b-edit-'+booking.id)">{{'edit-booking-link'|t}}</a>
                        </li>
                        <li class="cancel" v-else>
                          <p>{{'waiting-validation'|t}}</p>
                        </li>
                      </ul>
                      <ul v-if="! booking.isCancellable && mode == 'upcoming'" style="max-width: 300px;">
                        <li><p>{{'no-more-cancel'|t}}</p></li>
                      </ul>
                    </div>
                  </div>
                </b-list-group-item>

                <!-- Modal Edit booking event -->
                <b-modal :id="'b-edit-'+booking.id" content-class="edit-event" ref="editEventModal" size="lg" scrollable centered hide-footer hide-header>
                  <div class="modal-booking-edit" v-show="stepEdit === 0">
                    <h3 class="left-bullet">{{'edit-event'|t}}</h3>
                    <p>{{'edit-event-text'|t}}</p>

                    <ul>
                      <li><b>{{'edit-event-tickets'|t}}</b></li>
                      <li v-for="(ticket, index) in booking.tickets" :key="index">
                        <input type="checkbox" :id="'ticket-' + index" @change="toggleTicketSelection(index)">
                        <label :for="'ticket-' + index">Ticket {{ index + 1 }}</label>
                      </li>
                    </ul>

                    <p class="conditions">{{'edit-event-conditions'|t}}</p>

                    <div class="actions">

                      <div>
                        <button class="btn" v-if="selectedTickets.length" :disabled="!selectedTickets.length" @click.prevent="stepEdit = 1">
                          <span>{{'edit-event-cancel'|t}} {{ selectedTickets.length }} ticket(s)</span>
                        </button>
                      </div>

                      <a href="#" class="btn-link btn-link--small" @click.prevent="closeEventModal(booking.id)">{{'close'|t}}</a>

                    </div>
                  </div>

                  <div class="modal-booking-edit" v-show="stepEdit === 1">
                    <h3 class="left-bullet">{{'you-sure'|t}}</h3>
                    <p>{{'confirm-edit-text'|t}} <strong>{{ selectedTickets.length }} ticket(s)</strong> {{'action-undone'|t}}</p>

                    <div class="actions">

                      <div>
                        <button class="btn" v-if="selectedTickets.length" :disabled="!selectedTickets.length" @click.prevent="editEventBooking(booking.id)">
                          <span>{{'yes-cancel'|t}}</span>
                        </button>
                      </div>

                      <a href="#" class="btn-link btn-link--small" @click.prevent="stepEdit = 0">
                        {{'back'|t}}
                      </a>

                    </div>
                  </div>

                  <div class="modal-booking-edit" v-show="stepEdit === 2">
                    <h3 class="left-bullet">{{'edit-event-done'|t}}</h3>
                    <p>{{'edit-event-done-text'|t}}</p>

                    <div class="actions">

                      <a href="#" class="btn-link btn-link--small" @click.prevent="closeEventModal(booking.id)">{{'close'|t}}</a>

                    </div>
                  </div>

                </b-modal>

                <b-modal :id="'b'+booking.id" ref="bookingModal" size="lg" scrollable centered hide-footer hide-header>
                  <button type="button" aria-label="Close" class="close" @click="hideModal(index)"><b-img src="/storage/img/icon/icon-cross-close-modal.svg" class="cross-close-modal" width="16" height="16" /></button>

                  <div class="content">
                    <h3 class="left-bullet">{{'cancel-title-01'|t}}</h3>
                    <div class="room-item d-flex align-items-center">
                      <div class="img-wrapper">
                        <div class="room-image" :style="`background-image:url('storage/${booking.eventCover}')`"></div>
                      </div>
                      <div class="text-wrapper">
                        <h5>{{booking.event.name}}</h5>
                        <div class="booking-date">{{booking.date|formatDate}}</div>
                        <div class="booking-hours">{{'from'|t}} {{booking.from}}:00 {{'to'|t}} {{booking.to}}:00</div>
                        <div class="booking-price">{{booking.price}} €</div>
                      </div>
                    </div>
                    <p class="refund">
                      {{'cancel-text-01'|t}} <strong>{{booking.price/2}} €</strong> {{'cancel-text-02'|t}}
                    </p>
                    <ul class="btn-wrapper align-items-md-end">
                      <li class="order-md-2 mb-2 mb-md-0"><b-button @click="cancelOrder(booking.id, index)"><span>{{'cancel-btn-01'|t}}</span></b-button></li>
                      <li class="mr-md-3 order-md-1 text-center"><b-button @click="hideModal(index)" class="btn-link">{{'cancel-btn-02'|t}}</b-button></li>
                    </ul>
                  </div>

                </b-modal>

              </template>
            </b-list-group>
          </div>

        </div>
      </template>

      <template v-else>
        <div class="row d-md-flex justify-content-md-center pt-2 pt-md-4 pb-2 pb-md-3">
          <div class="col-md-8 col-lg-7 col-xl-6">
            <h3 class="left-bullet">{{'empty-title-01'|t}}</h3>
            <p>{{'empty-text-02'|t}}</p>
            <router-link class="btn mt-2 mt-md-3 mb-2 mb-md-0" to="/events" active-class="active"><span>{{'book-an-event'|t}}</span></router-link>
          </div>
        </div>
      </template>
    </div>

    <!--
        Rooms
    -->
    <div class="container cart booking" v-if="type == 'rooms'">
      <template v-if="bookings && bookings.length && $store.rooms.content">
        <div class="row">
          <div class="col-md-12 col-lg-10">
            <b-list-group class="cart-list booking-list">
              <template v-for="(booking,index) in bookings" v-if="booking.room_id">
                <b-list-group-item class="cart-item booking-item d-md-flex align-items-md-center justify-content-md-between">
                  <div class="img-wrapper">
                    <div class="room-image" :style="'background-image:url('+$store.rooms.content[booking.room_id-1].images[0]+')'"></div>
                  </div>
                  <div class="text-wrapper d-md-flex align-items-md-start justify-content-md-between">
                    <div class="left-infos">
                        <h5>
                            {{$store.rooms.content[booking.room_id-1].name}}
                        </h5>
                        <div class="booking-date">
                            {{booking.date|formatDate}}
                        </div>
                        <div class="booking-hours">
                            {{'from'|t}} {{booking.from}}:00 {{'to'|t}} {{booking.to}}:00
                        </div>
                        <div class="booking-price">
                            {{
                                booking.balance_amount ?booking.price + booking.balance_amount : booking.price
                            }} €
                        </div>
                    </div>
                    <div class="right-infos">
                      <div class="access d-flex">
                        <simple-svg :filepath="'/storage/img/icon/icon-lock-access.svg'" />
                        <p>{{'access-code-text'|t}}<br /> <span v-if="booking.code">{{booking.code}}</span><span v-else>{{'to'|t}}</span></p>
                      </div>

                      <ul class="links"  v-if="booking.isCancellable">
                        <!-- <li><a href="#">{{'print-link'|t}}</a></li>
                        <li><a href="#">{{'room-details-link'|t}}</a></li> -->
                        <li class="cancel"><b-button v-b-modal="'b'+booking.id">{{'cancel-booking-link'|t}}</b-button></li>
                      </ul>
                      <ul v-if="! booking.isCancellable && mode == 'upcoming'" style="max-width: 300px;">
                        <li><p>{{'no-more-cancel'|t}}</p></li>
                      </ul>
                    </div>
                  </div>
                </b-list-group-item>
                <b-modal :id="'b'+booking.id" ref="bookingModal" size="lg" scrollable centered hide-footer hide-header>
                  <button type="button" aria-label="Close" class="close" @click="hideModal(index)"><b-img src="/storage/img/icon/icon-cross-close-modal.svg" class="cross-close-modal" width="16" height="16" /></button>

                  <div class="content">
                    <h3 class="left-bullet">{{'cancel-title-01'|t}}</h3>
                    <div class="room-item d-flex align-items-center">
                      <div class="img-wrapper">
                        <div class="room-image" :style="'background-image:url('+$store.rooms.content[booking.room_id-1].images[0]+')'"></div>
                      </div>
                      <div class="text-wrapper">
                        <div class="room-name">{{$store.rooms.content[booking.room_id-1].name}}</div>
                        <div class="booking-date">{{booking.date|formatDate}}</div>
                        <div class="booking-hours">{{'from'|t}} {{booking.from}}:00 {{'to'|t}} {{booking.to}}:00</div>
                        <div class="booking-price">{{booking.price}} €</div>
                      </div>
                    </div>
                    <p class="refund">
                      {{'cancel-text-01'|t}} <strong>{{booking.price/2}} €</strong> {{'cancel-text-02'|t}}
                    </p>
                    <ul class="btn-wrapper align-items-md-end">
                      <li class="order-md-2 mb-2 mb-md-0"><b-button @click="cancelOrder(booking.id, index)"><span>{{'cancel-btn-01'|t}}</span></b-button></li>
                      <li class="mr-md-3 order-md-1 text-center"><b-button @click="hideModal(index)" class="btn-link">{{'cancel-btn-02'|t}}</b-button></li>
                    </ul>
                  </div>

                </b-modal>
              </template>
            </b-list-group>
          </div>

        </div>
      </template>
      <template v-else>
        <div class="row d-md-flex justify-content-md-center pb-2 pb-md-3">
          <div class="col-md-8 col-lg-7 col-xl-6">
            <h3 class="left-bullet">{{'empty-title-01'|t}}</h3>
            <p>{{'empty-text-01'|t}}</p>
            <router-link class="btn mt-2 mt-md-3 mb-2 mb-md-0" to="/book" active-class="active"><span>{{'book-a-room'|t}}</span></router-link>
          </div>
        </div>
      </template>
    </div>
	</layout-component>
</template>

<script>
  export default {
    data() {
      return {
        bookings: null,
        bookingsData: null,
        all: null,
        hasError: false,
        hasRefund: false,
        mode: 'upcoming',
        type: 'rooms',
        selectedTickets: [],
        stepEdit: 0
      }
    },
    methods: {
      setData(data) {
        this.bookingsData = data
        this.bookings = this.bookingsData.upcoming
        this.all = this.bookingsData.all
      },
      cancelOrder(bookingId, index) {
        this.$refs.bookingModal[index].hide()
        Vue.axios.delete('/booking/'+bookingId).then(({data}) => {
          Vue.axios.get('/booking').then( ({data}) => {
            this.bookingsData = data
            this.changeMode()
            this.hasRefund = true;
            this.hasError = false;
            setTimeout(function(){
              animateScrollTo(document.querySelector('.alert'), {
                offset: -100,
                passive: true
              });
            }, 50);
          });
        }).catch(({error}) => {
          this.hasRefund = false;
          this.hasError = true;
          setTimeout(function(){
            animateScrollTo(document.querySelector('.alert'), {
              offset: -100,
              passive: true
            });
          }, 50);
        })
      },
      toggleTicketSelection(index) {
        const idx = this.selectedTickets.indexOf(index);
        if (idx === -1) {
          this.selectedTickets.push(index);
        } else {
          this.selectedTickets.splice(idx, 1);
        }
      },
      openEditModal(id) {
        this.selectedTickets = [];
        this.stepEdit = 0;
        this.$bvModal.show(id);
      },
      confirmEventEdit(bookingId) {
        this.$bvModal.hide('b-edit-'+bookingId);
      },
      editEventBooking(bookingId) {
        Vue.axios.put(`/booking/${bookingId}`, {
          tickets: this.selectedTickets.length,
        })
        .then(response => {
          this.stepEdit = 2;

          Vue.axios.get('/booking').then( ({data}) => {
            this.setData(data)
          });

        })
        .catch(error => {
          // Gérer l'erreur
        });
      },
      closeEventModal(bookingId) {
        this.$bvModal.hide('b-edit-'+bookingId);
        this.selectedTickets = [];
        this.stepEdit = 0;
      },
      hideModal(index) {
        this.$refs.bookingModal[index].hide()
      },
      changeMode() {
        if(this.mode == 'past') this.bookings = this.bookingsData.past
        else this.bookings = this.bookingsData.upcoming
      },
      changeType(param) {
        this.type = param;
      }
    },

    computed: {
      events() {
        if (this.all) {
          if(this.mode == 'upcoming') {
            return this.all.filter(function (item) {
              if (item.event_id && moment().isBefore(moment(item.date))) {
                return true;
              }

              return false;
            });
          }

          return this.all.filter(item => item.event_id && moment().isAfter(moment(item.date)));
        }
      },
      rooms() {
        if (this.all) {
          return this.all.filter(item => item.room_id);
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      Vue.axios.get('/booking').then( ({data}) => {
        next(vm => vm.setData(data))
      });
    }
  }
</script>

<i18n>
    {
      "en": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>My bookings</span></span>",
        "bookings": "Bookings",
        "profile": "Profile",
        "upcoming-booking": "Upcoming booking(s)",
        "past-booking": "Past booking(s)",
        "from": "from",
        "to": "to",
        "access-code-text": "Your room access code is",
        "print-link": "Print confirmation",
        "room-details-link": "Room details",
        "cancel-booking-link": "Cancel booking",
        "edit-booking-link": "Edit booking",
        "no-more-cancel": "Sessions scheduled to start in less than 24 hours cannot be cancelled.",
        "cancel-title-01": "Are you sure?",
        "cancel-text-01": "Cancellation possible up to 24 hours before the date of the session (refund of 50%). You will receive a refund of",
        "cancel-text-02": "through the payment method used for the reservation.",
        "cancel-btn-01": "Cancel my booking",
        "cancel-btn-02": "Keep my booking",
        "empty-title-01": "Your bookings are empty",
        "empty-text-01": "Find a room that works around your life & budget.",
        "empty-text-02": "Find an event that works around your life & budget.",
        "book-a-room": "Book a room",
        "book-an-event": "Book an event",
        "pending" : "Payment validation pending",
        "error-title" : "Error",
        "error-text" : "There was an error processing your refund, please try again later or contact us by email: <a href='mailto:info@sonotron.lu'>info@sonotron.lu</a>",
        "refund-title" : "Success",
        "refund-text" : "Your booking has been cancelled. You will soon receive an email confirmation.",
        "title-events": "Events",
        "title-rooms": "Rooms",
        "event-free": "Free",
        "event-details": "Event details",
        "edit-booking-link": "Edit my booking",
        "waiting-validation" : "Waiting for validation",
        "edit-event": "Edit my booking",
        "edit-event-text": "You can't make it? No worries, you can modify the number of tickets here. Freeing up a spot will allow someone else to participate.",
        "edit-event-tickets": "Select the ticket(s) to cancel",
        "edit-event-conditions": "Please note that cancellations are final and will not be refunded.",
        "edit-event-cancel": "Cancel",
        "close": "Close",
        "you-sure": "Are you sure?",
        "confirm-edit-text": "You are about to cancel",
        "action-undone": "This action is irreversible and tickets will not be refunded.",
        "yes-cancel": "Yes, cancel",
        "back": "Back",
        "edit-event-done": "Done!",
        "edit-event-done-text": "Your booking has been successfully modified. We appreciate your consideration in giving others the opportunity to take part."
      },
      "fr": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>Mes réservations</span></span>",
        "bookings": "Reservations",
        "profile": "Profil",
        "upcoming-booking": "Réservation(s) à venir",
        "past-booking": "Réservation(s) précédente(s)",
        "from": "De",
        "to": "À",
        "access-code-text": "Votre code d’accès à la salle est :",
        "print-link": "Imprimer la confirmation",
        "room-details-link": "Informations sur la salle",
        "cancel-booking-link": "Annuler la réservation",
        "edit-booking-link": "Modifier la réservation",
        "no-more-cancel": "Les sessions planifiées dans moins de 24 heures ne peuvent pas être annulées.",
        "cancel-title-01": "Etes-vous sur(e) ?",
        "cancel-text-01": "Vous pouvez annuler votre réservation jusqu’à 24 heures avant la date de la séance (remboursement à hauteur de 50 %). Vous recevrez un remboursement de",
        "cancel-text-02": "par le même moyen de paiement que celui que vous avez utilisé pour réserver.",
        "cancel-btn-01": "Annuler ma reservation",
        "cancel-btn-02": "Conserver ma reservation",
        "empty-title-01": "La liste de vos reservations est vide.",
        "empty-text-01": "Trouvez la salle idéale pour vous et votre budget.",
        "empty-text-02": "Trouvez l'évènement idéal pour passer une bonne journée",
        "book-an-event": "Réserver un event",
        "book-a-room": "Reserver une salle",
        "pending" : "Paiement en cours de validation",
        "error-title" : "Erreur",
        "error-text" : "Une erreur est survenue avec votre remboursement, veuillez réessayer plus tard ou nous contacter par email: <a href='mailto:info@sonotron.lu'>info@sonotron.lu</a>",
        "refund-title" : "Confirmation",
        "refund-text" : "Votre réservation est bien annulée. Vous allez recevoir une confirmation par email.",
        "title-events": "évènements",
        "title-rooms": "Salles",

        "event-free": "Gratuit",
        "event-details": "Détails de l’événement",
        "edit-booking-link": "Modifier ma réservation",
        "waiting-validation" : "En attente de validation",
        "edit-event": "Modifier ma réservation",
        "edit-event-text": "Vos plans ont changé ? Pas de panique, vous pouvez modifier le nombre de tickets ici. Libérer des places permets aux personnes inscrites dans la liste d’attente de participer à l'évènement.",
        "edit-event-tickets": "Sélectionnez le(s) ticket(s) à annuler",
        "edit-event-conditions": "Veuillez noter que les annulations sont définitives et non-remboursables.",
        "edit-event-cancel": "Annuler",
        "close": "Fermer",
        "you-sure": "Êtes-vous sûr ?",
        "confirm-edit-text": "Vous êtes sur le point d’annuler",
        "action-undone": "Cette action est irréversible et les tickets ne seront pas remboursés.",
        "yes-cancel": "Oui, annuler",
        "back": "Retour",
        "edit-event-done": "C’est fait !",
        "edit-event-done-text": "Votre réservation a été modifiée avec succès. Nous vous remercions de votre gentillesse en donnant à d'autres la possibilité de participer."
      }
    }

  </i18n>
